/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

// @flow

const PREFIX = '@@toast/';

const ADD = `${PREFIX}ADD_TOAST_MESSAGE`;
const REMOVE = `${PREFIX}REMOVE_TOAST_MESSAGE`;
const REMOVE_ALL = `${PREFIX}REMOVE_ALL_TOAST_MESSAGE`;

export {
  ADD as ADD_TOAST_MESSAGE,
  REMOVE as REMOVE_TOAST_MESSAGE,
  REMOVE_ALL as REMOVE_ALL_TOAST_MESSAGE,
};

function createMessage(id, text, type, url, dismissAfter) {
  return {
    id,
    text,
    type,
    url,
    dismissAfter,
  };
}

export function createModule(options = {}) {
  const { dismissInterval = 5000 } = options;

  let maxToastId = 0;

  const state = {
    messages: [],
  };

  const getters = {
    toastMessages: state => state.messages,
  };

  const actions = {
    [ADD]({ commit }, { text, type = 'info', url = undefined, dismissAfter = dismissInterval }) {
      const id = ++maxToastId;

      commit(ADD, createMessage(id, text, type, url, dismissAfter));
      setTimeout(() => commit(REMOVE, id), dismissAfter);
    },

    [REMOVE]({ commit }, id) {
      commit(REMOVE, id);
    },

    [REMOVE_ALL]({ commit }) {
      commit(REMOVE_ALL);
    },
  };

  const mutations = {
    [ADD](state, data) {
      state.messages.push(data);
    },

    [REMOVE](state, id) {
      state.messages = state.messages.filter(m => m.id !== id);
    },

    [REMOVE_ALL](state) {
      state.messages = [];
    },
  };

  return {
    state,
    getters,
    actions,
    mutations,
  };
}
